import { Link } from "react-router";
import AiAgentsLogo from "@/assets/eva-logo2026.png";

export function Logo() {
  return (
    <Link
      to="/"
      className="outline-none focus-visible:ring-2 ring-offset-2 ring-link-lighter"
      data-testid="logo-link"
    >
      <img src={AiAgentsLogo} alt="EVA Logo" className="h-[40px]" />
    </Link>
  );
}
